import { Injectable, signal } from "@angular/core";

@Injectable({ providedIn: 'root' })

export class LocationRegionCategoryService {
   at_home = signal<boolean>(false);
    page = signal<number>(1);
    type = signal<string>('');
    search_id = signal<string>('');
    searchedItem = signal<string>('');
    current_page = signal<number>(0);
    categorySlug = signal<string>('');
    resultExp = signal<any[]>([]);
    country = signal<string>('');
    state = signal<string>('');
    city = signal<any>('');
    category_id = signal<any>(0);
    price_filter_search = signal<any>([]);



    setPage(value) {
        this.page.set(value);
    }

    setType(value) {
        this.type.set(value);
    }

    setSearchId(value) {
        this.search_id.set(value);
    }

    setSearchedItem(value) {
        this.searchedItem.set(value);
    }

    setCurrentPage(value) {
        this.current_page.set(value);
    }

    setCategorySlug(value) {
        this.categorySlug.set(value);
    }

    setResultExp(value:any){
        this.resultExp.set(value);
    }

    setAtHome(value:boolean){
        this.at_home.set(value);
    }

    setCity(value:any){
        this.city.set(value);
    }

    setState(value:any){
        this.state.set(value);
    }

    setCountry(value:any){
        this.country.set(value);
    }

    setCategoryId(value:any){
        this.category_id.set(value);
    }

    setPriceFilter(value: any) {
        this.price_filter_search.set(value);
    }
}